module.exports = __webpack_public_path__ + "media/images/brand/400/MARQUESBRANDINGCO LOGO X-874da623ecaf53b64af9e86eef39151d.png";